import { Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import MetricsSelector from '../../../components/MetricsSelector';
import ProductTrendsCards from '../../../components/ProductTrends/ProductTrendsCards';
import Spinner from '../../../components/Spinner';
import { Page } from '../../../constants/pageTitles';
import { daysAgoISODate, todayISODate } from '../../../helpers/dateUtils';
import useFetch from '../../../helpers/useFetch';

const ProductTrendsPage = () => {
  const fetch = useFetch();
  const { accountId, domainId } = useParams();
  const [allTrends, setAllTrends] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialPeriodDays = 14;

  const [error, setError] = useState();
  // Store ISO date strings (YYYY-MM-DD)
  const [startDate, setStartDate] = useState(daysAgoISODate(initialPeriodDays - 1));
  const [endDate, setEndDate] = useState(todayISODate());

  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/productTrends/${startDate}/${endDate}`;

  useEffect(() => {
    setAllTrends(undefined);
    setLoading(true);
    fetch(fetchUrl)
      .then((res) => {
        setAllTrends(res);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, [fetch, fetchUrl]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Metadata title={`${Page['productTrends']}`} />{' '}
      <Grid>
        <Grid.Col span={6} className="leftHolder">
          <MetricsSelector
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            rowSize="12"
          />
        </Grid.Col>
      </Grid>
      {allTrends && <ProductTrendsCards trends={allTrends} startDate={startDate} endDate={endDate} />}
    </>
  );
};

export default ProductTrendsPage;
